export default "__VITE_ASSET__BKLyFSf3__"